export default "__VITE_ASSET__BwloLLIo__"